import { useRef, useEffect } from 'react';

// T-F07: the list row menu's "Update shipping info" opens the existing edit
// form with #shipment-info; the form then shows its Shipment info block.
export const SHIPMENT_INFO_ANCHOR = 'shipment-info';

export const useShipmentInfoAnchor = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.location.hash === `#${SHIPMENT_INFO_ANCHOR}`) {
      ref.current?.scrollIntoView?.({ block: 'start' });
    }
  }, []);

  return ref;
};
